/**
 * The auth route. `/login` is a load-bearing contract: the SPA router
 * branches on it, the global 401 handler routes to it, and every sign-out
 * lands there. Defined once so those uses cannot drift apart.
 */
export const LOGIN_PATH = "/login";
